"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHostSelector = exports.useHostDispatch = exports.sharedContext = exports.extendableMiddleware = exports.rootStateFactory = exports.rootReducer = void 0;
var redux_1 = require("redux");
var toolkit_1 = require("@reduxjs/toolkit");
var table_slice_1 = __importDefault(require("./slices/table.slice"));
var faults_model_1 = require("./models/faults.model");
var faults_slice_1 = __importDefault(require("./slices/faults.slice"));
var filterBar_slice_1 = __importDefault(require("./slices/filterBar.slice"));
var modal_model_1 = require("./models/modal.model");
var modal_slice_1 = __importDefault(require("./slices/modal.slice"));
var vehicleInfo_model_1 = require("./models/vehicleInfo.model");
var vehicleInfo_slice_1 = __importDefault(require("./slices/vehicleInfo.slice"));
var table_model_1 = require("./models/table.model");
var vehicles_api_1 = require("./apis/vehicles.api");
Object.defineProperty(exports, "sharedContext", { enumerable: true, get: function () { return vehicles_api_1.sharedContext; } });
Object.defineProperty(exports, "useHostDispatch", { enumerable: true, get: function () { return vehicles_api_1.useHostDispatch; } });
Object.defineProperty(exports, "useHostSelector", { enumerable: true, get: function () { return vehicles_api_1.useHostSelector; } });
var vehicle_model_1 = require("./models/vehicle.model");
var login_model_1 = require("./models/login.model");
var user_model_1 = require("./models/user.model");
var featureFlags_model_1 = require("./models/featureFlags.model");
var safetyEventDetails_model_1 = require("./models/safetyEventDetails.model");
var notificationMessages_model_1 = require("./models/notificationMessages.model");
var dealers_model_1 = require("./models/dealers.model");
var vehicles_slice_1 = __importDefault(require("./slices/vehicles.slice"));
var login_slice_1 = __importDefault(require("./slices/login.slice"));
var user_slice_1 = __importDefault(require("./slices/user.slice"));
var featureFlags_slice_1 = __importDefault(require("./slices/featureFlags.slice"));
var safetyEventDetails_slice_1 = __importDefault(require("./slices/safetyEventDetails.slice"));
var notificationMessages_slice_1 = __importDefault(require("./slices/notificationMessages.slice"));
var dealers_slice_1 = __importDefault(require("./slices/dealers.slice"));
var faults_middleware_1 = __importDefault(require("./middleware/faults.middleware"));
var vehicleInfo_middleware_1 = __importDefault(require("./middleware/vehicleInfo.middleware"));
var reducers = (_a = {
        vehicles: vehicles_slice_1.default,
        login: login_slice_1.default,
        user: user_slice_1.default,
        notificationMessages: notificationMessages_slice_1.default
    },
    _a[vehicles_api_1.vehicleApi.reducerPath] = vehicles_api_1.vehicleApi.reducer,
    _a.dealers = dealers_slice_1.default,
    _a.table = table_slice_1.default,
    _a.faults = faults_slice_1.default,
    _a.filterBar = filterBar_slice_1.default,
    _a.modal = modal_slice_1.default,
    _a.vehicleInfo = vehicleInfo_slice_1.default,
    _a.featureFlags = featureFlags_slice_1.default,
    _a.safetyEventDetails = safetyEventDetails_slice_1.default,
    _a);
exports.rootReducer = (0, redux_1.combineReducers)(reducers);
var rootStateFactory = function () { return ({
    vehicles: (0, vehicle_model_1.vehiclesListFactory)(),
    login: (0, login_model_1.loginStateFactory)(),
    user: (0, user_model_1.userStateFactory)(),
    notificationMessages: (0, notificationMessages_model_1.notificationMessagesStateFactory)(),
    dealers: (0, dealers_model_1.defaultDealersStateFactory)(),
    table: (0, table_model_1.TableStateFactory)(),
    faults: (0, faults_model_1.faultsStateFactory)(),
    filterBar: {},
    modal: (0, modal_model_1.modalStateFactory)(),
    vehicleInfo: (0, vehicleInfo_model_1.defaultVehicleInfoStateFactory)(),
    featureFlags: (0, featureFlags_model_1.featureFlagsStateFactory)(),
    safetyEventDetails: (0, safetyEventDetails_model_1.safetyEventDetailsStateFactory)(),
}); };
exports.rootStateFactory = rootStateFactory;
exports.extendableMiddleware = (0, toolkit_1.createListenerMiddleware)();
var store = function (storeName, devtoolEnabled) {
    if (storeName === void 0) { storeName = 'Module'; }
    if (devtoolEnabled === void 0) { devtoolEnabled = true; }
    var devTools = (devtoolEnabled) ? {
        name: "".concat(storeName, " - State"),
    } : {};
    return (0, toolkit_1.configureStore)({
        reducer: exports.rootReducer,
        preloadedState: (0, exports.rootStateFactory)(),
        devTools: devTools,
        middleware: function (getDefaultMiddleware) { return getDefaultMiddleware()
            .concat(vehicles_api_1.vehicleApi.middleware)
            .concat(faults_middleware_1.default)
            .concat(vehicleInfo_middleware_1.default)
            .prepend(exports.extendableMiddleware.middleware); },
    });
};
if (!window.sharedStore) {
    window.sharedStore = store('Shared Store', true);
}
exports.default = store;
